export default __webpack_public_path__ + "static/media/Icon-sort.14374f65.svg";